export const BID_TYPES = { BID_PHONE: 'bid_phone', BID_AUDIENCE: 'bid_audience', BID_APP: 'bid_app' };
export const FINISHED_STATES = { SOLD: 'sold', SOLD_CONDITIONALLY: 'sold_conditionally', UNSOLD: 'unsold' };
export const AUCTIONS_CATALOG_ID = window.$('script[data-auctions-catalog-id]').data('auctions-catalog-id');
export const SUBSCRIPTION_STATES = { connected: 'connected', disconnected: 'disconnected', rejected: 'rejected' };
export const MAXIMUM_EVENTS_COUNT = 6;
export const FIRST_PAGE = 1;
export const SECOND_PAGE = 2;
export const THIRD_PAGE = 3;
export const PAGINATION_OPTIONS = { 25: 25, 50: 50, 100: 100 };
export const DEFAULT_PER_PAGE = 50;
export const IN_PROGRESS_STATE = 'in_progress';
export const INCOMING_STATE = 'incoming';
export const INTERNET_TYPE = 'internet';
export const HAMMER_TYPE = 'hammer';
export const AUCTIONS_CATALOG_STATES = {
  INCOMING: 'incoming',
  READY: 'ready',
  IN_PROGRESS: 'in_progress',
  FINISHED: 'finished',
};
export const AUCTIONS_CATALOG_TYPE = { INTERNET: 'InternetAuctionCatalogue' };
export const EMPLOYEES_ORDERS_PANEL = 'EmployeesOrdersPanel';



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/consts.js